import { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import FilterChip from 'LuxKit/Chips/FilterChip'
import { getSearchThemeTitle } from 'components/Experiences/hooks/useExperienceThemes'
import type { ExperienceCategoryFilter } from './experienceCategoryFiltering'

interface Props {
  category: ExperienceCategoryFilter
  isSelected: boolean
  isDisabled?: boolean
  onSelect: (categoryId: number | undefined) => void
}

function ExperienceCategoryChip({ category, isSelected, isDisabled, onSelect }: Props) {
  const intl = useIntl()

  const handleClick = useCallback(() => {
    onSelect(isSelected ? undefined : category.id)
  }, [category.id, isSelected, onSelect])

  return (
    <FilterChip selected={isSelected} aria-pressed={isSelected} disabled={isDisabled} size="medium" onClick={handleClick}>
      {getSearchThemeTitle(intl, category.id, category.label)}
    </FilterChip>
  )
}

export default memo(ExperienceCategoryChip)
